import React from 'react'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/receivement/ReceivementState'
import theme from 'src/styles/theme'
import { useSelector } from 'src/utils/store'
import Modal from '../../../../../../components/Modal'
import * as S from './ModalObservation.styles'
import ModalObservationInput from './ModalObservationInput'

interface Props {
  show: boolean;
  id?: number;
  closeObservationModal: () => void;
  wrongProduct?: boolean;
  maxLength: number;
}

const ModalObservation = ({
  show, closeObservationModal, id, wrongProduct, maxLength = 400,
}: Props) => {
  const dispatch = useDispatch()

  const { observation } = useSelector((state) => state.receivement.observation)

  const updateObservation = React.useCallback(() => {
    if (!id) return
    if (wrongProduct) dispatch(actions.patchBatchObservation({ batchId: id, observation }))
    else dispatch(actions.patchItemArObservation({ itemArId: id, observation }))
    closeObservationModal()
  }, [closeObservationModal, dispatch, id, observation, wrongProduct])

  return (
    <Modal
      testId='observation-modal'
      show={show}
      centered
      size='lg'
      title='Anotações'
      titleStyle={{ fontSize: '1.3rem', fontFamily: 'Work Sans', fontWeight: 'bold' }}
      IconLeft={() => <S.PencilStyled />}
      closeButtonAction={closeObservationModal}
      bodyStyle={{
        backgroundColor: theme.colors.gray,
        borderBottomRightRadius: 4,
        borderBottomLeftRadius: 4,
      }}
      body={(
        <>
          <S.BodyContainer>
            <S.DescriptionContainer>
              <S.ChatRightTextFillFillStyled />
              <S.DescriptionTextContainer>
                <S.DescriptionText>
                  Observação para o Operador <br />
                </S.DescriptionText>
                <S.DescriptionText>
                  Faça uma <S.DescriptionBold>breve</S.DescriptionBold> descrição sobre o que deseja
                  comentar.
                </S.DescriptionText>
              </S.DescriptionTextContainer>
            </S.DescriptionContainer>
            <ModalObservationInput maxLength={maxLength} />
            <S.ButtonWrapper>
              <S.ConfirmButton
                data-testid='modal-observation-submit'
                type='button'
                onClick={updateObservation}
              >
                Confirmar
              </S.ConfirmButton>
              <S.CancelButton type='button' onClick={closeObservationModal}>
                Cancelar
              </S.CancelButton>
            </S.ButtonWrapper>
          </S.BodyContainer>
        </>
      )}
    />
  )
}

export default React.memo(ModalObservation)
